import { classnames } from '@aibees/shared/utils';
import { forwardRef, memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { Grid2Props as Props } from './types';

export const Grid2 = memo(
  forwardRef<HTMLDivElement, Props>(
    ({ className, children, ...props }, ref) => {
      return (
        <Styled.Wrapper
          ref={ref}
          className={classnames('Grid2', className)}
          sx={SX.root}
          display="flex"
          flexDirection="row"
          {...props}
        >
          {children}
        </Styled.Wrapper>
      );
    }
  )
);

Grid2.displayName = 'Grid2';
